import Swiper, { Pagination, Autoplay } from 'swiper';
Swiper.use([Pagination, Autoplay]);

/**
 * STANDALONE HERO SLIDER MODULE
 */
export namespace HeroSlider {
	let setupSlider = () => {
		let heroSliders = document.querySelectorAll('.js-hero-slider');

		/**
		 * Initialize all hero sliders on a page, set appropriate classes for identifying specific instances
		 */
		heroSliders.forEach((slider, index) => {
			let parent = slider.closest('.hero-slider__wrapper');
			let pagination = parent.querySelector('.swiper-pagination');
			parent.classList.add(`hero-slider__wrapper-${index}`);
			pagination.classList.add(`swiper-pagination-${index}`);
			slider.classList.add(`hero-slider-${index}`);
			let fpSliderList = [];
			let autorotate = slider.getAttribute('data-autorotate');
			let autorotateDelay = slider.getAttribute('data-autorotateDelay');

			let fpSlider = new Swiper(`.hero-slider-${index}`, {
				slidesPerView: 1,
				speed: 400,
				spaceBetween: 0,
				centeredSlides: true,
				loop: true,
				simulateTouch: true,
				a11y: {
					enabled: true,
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide',
					firstSlideMessage: 'This is the First Slide',
					lastSlideMessage: 'This is the Last Slide'
				},
				// @ts-ignore
				autoplay: autorotate === 'True' ? { delay: autorotateDelay ? autorotateDelay : 5000 } : false,

				pagination: {
					el: `.swiper-pagination-${index}`,
					clickable: true
				}
			});

			/**
			 * Play Pause Button
			 */
			if (autorotate == 'True') {
				let paginationButton = parent.querySelector('.js-paginationButton');
				paginationButton.classList.add('hero-slider__pagination-button--autoplay');

				paginationButton.addEventListener('click', (event) => {
					if (paginationButton.classList.contains('hero-slider__pagination-button--paused')) {
						fpSlider.autoplay.start();
						paginationButton.classList.remove('hero-slider__pagination-button--paused');
					} else {
						fpSlider.autoplay.stop();
						paginationButton.classList.add('hero-slider__pagination-button--paused');
					}
					event.preventDefault();
				});
			}

			fpSliderList.push(fpSlider);
			fpSlider.init();
		});
	}

	export const init = () => {
		setupSlider();
	}
}


/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', HeroSlider.init);
} else {  // `DOMContentLoaded` has already fired
	HeroSlider.init();
}
